'use client';

import type { NumberFormatBaseProps } from 'react-number-format';
import { NumberFormatBase, NumericFormat } from 'react-number-format';

export function formatPhoneNumber(phoneNumber: string) {
  var cleaned = ('' + phoneNumber).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return '';
}

export function FormatNumber(props: NumberFormatBaseProps) {
  // const { format } = useNumericFormat({ thousandSeparator: ',', decimalSeparator: '.', ...props });

  if (props.type === 'tel') {
    return <NumberFormatBase type="tel" displayType="text" format={number => formatPhoneNumber(number)} {...props} />;
  }

  return <NumericFormat type="text" {...props} />;
}
